export function pathEndsWithSlash(param: string): string {
    if (param[param.length - 1] === '/') {
        return param.slice(0, -1);
    }

    return param;
}
